import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-2 mt-2 w-full" }
const _hoisted_2 = { class: "flex flex-col rounded-md border border-gray-lp-2100 w-full text-black-lp-300 text-sm" }
const _hoisted_3 = /*#__PURE__*/_createVNode("thead", { class: "border-b font-semibold" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { class: "w-10 px-3 py-3 text-left" }, "No"),
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-3 text-left" }, "Variable"),
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-3 text-left" }, "Value"),
    /*#__PURE__*/_createVNode("th", { class: "w-10 px-3 py-3" })
  ])
], -1)
const _hoisted_4 = { class: "px-3 py-2" }
const _hoisted_5 = { class: "px-3 py-2 w-2/3" }
const _hoisted_6 = {
  key: 0,
  class: "py-1"
}
const _hoisted_7 = { class: "px-3 py-2 w-1/3" }
const _hoisted_8 = {
  key: 0,
  class: "py-1"
}
const _hoisted_9 = {
  key: 0,
  class: "px-3 py-2 text-center"
}
const _hoisted_10 = {
  key: 0,
  class: "px-3 py-1.5 w-full"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "Tambah variable baru", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock(_component_DataWrapper, {
    label: "Variable pesan",
    asterisk: ""
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        (!_ctx.detail)
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 0,
              compact: "",
              "custom-class": "py-1 px-3",
              icon: "book",
              onClick: _ctx.showDictionary
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_2, [
          _createVNode("table", {
            class: ["w-full", `${_ctx.tableFontSize}`]
          }, [
            _hoisted_3,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
                return (_openBlock(), _createBlock("tr", {
                  key: index,
                  class: ["border-gray-lp-2100", { 'border-b': !_ctx.detail || index !== _ctx.data.length - 1 }]
                }, [
                  _createVNode("td", _hoisted_4, _toDisplayString(index + 1), 1),
                  _createVNode("td", _hoisted_5, [
                    (_ctx.detail)
                      ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(item.variable), 1))
                      : _withDirectives((_openBlock(), _createBlock("input", {
                          key: 1,
                          type: "text",
                          "onUpdate:modelValue": ($event: any) => (item.variable = $event),
                          class: "w-full border rounded-md h-9 px-3 placeholder-gray-lp-600 focus:outline-none focus:shadow",
                          placeholder: "Isi variable",
                          maxlength: 100
                        }, null, 8, ["onUpdate:modelValue"])), [
                          [_vModelText, item.variable]
                        ])
                  ]),
                  _createVNode("td", _hoisted_7, [
                    (_ctx.detail)
                      ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(item.value.value), 1))
                      : (_openBlock(), _createBlock(_component_CustomDropdown, {
                          key: 1,
                          modelValue: item.value,
                          "onUpdate:modelValue": ($event: any) => (item.value = $event),
                          preventUnselect: "",
                          "selected-item": item.value,
                          options: _ctx.listValue,
                          placeholder: "Pilih value"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "selected-item", "options"]))
                  ]),
                  (!_ctx.detail)
                    ? (_openBlock(), _createBlock("td", _hoisted_9, [
                        (_ctx.data.length > 1)
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              class: "text-red-lp-100",
                              onClick: ($event: any) => (_ctx.onDelete(index))
                            }, [
                              _createVNode(_component_Icons, {
                                name: "white-trash",
                                class: "w-4"
                              })
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ])
          ], 2),
          (!_ctx.detail)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode("button", {
                  class: ["flex items-center gap-2 font-semibold text-xs", 
              _ctx.data.length >= 20
                ? 'text-gray-lp-600 cursor-not-allowed'
                : 'text-red-lp-100 cursor-pointer'
            ],
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAdd && _ctx.onAdd(...args))),
                  disabled: _ctx.data.length >= 20
                }, [
                  _createVNode(_component_Icons, {
                    name: "plus-circle",
                    class: "w-5"
                  }),
                  _hoisted_11
                ], 10, ["disabled"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}